module.exports = __webpack_public_path__ + "static/media/trash.5dda1f39.svg";